import React from 'react';
import illustration from '@/assets/noSearchResults.svg';
import { EmptyState } from '../EmptyState';

type Props = {
  searchTerm: string;
};

export const NoActiveFlyersFound: React.FC<Props> = ({ searchTerm }) => (
  <EmptyState
    title="No active flyers found"
    description={`There are no active flyers with "${searchTerm}". However we found some expired flyers below.`}
    illustration={illustration}
  />
);
